// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  memoryLocalCache,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configurações do Firebase
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyCMJITOqkawYCbUXNWaSTEKZPpSmVxMZkY",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "alpha-translations.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "alpha-translations",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "alpha-translations.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "860118025738",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:860118025738:web:132fde60727624057701f3",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YTCQNBNQGB",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar serviços
const auth = getAuth(app);

// Firestore com o cache configurado JÁ na inicialização (API moderna do SDK).
// - persistentLocalCache + persistentMultipleTabManager: cache offline em
//   IndexedDB que FUNCIONA com múltiplas abas abertas. O antigo
//   enableIndexedDbPersistence dava "failed-precondition" quando o usuário
//   tinha mais de uma aba do app aberta, degradando o Firestore no mobile e
//   deixando leituras (getDoc) penduradas — o que travava a tela no "loading".
// - Se o ambiente não suportar IndexedDB (ex.: Safari em aba privada), cai para
//   cache em memória, que nunca depende do IndexedDB e portanto não pendura.
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (error) {
  console.warn(
    "Cache persistente do Firestore indisponível; usando cache em memória:",
    error
  );
  db = initializeFirestore(app, { localCache: memoryLocalCache() });
}

const storage = getStorage(app);

// Configurar persistência do login (auth)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Erro ao configurar persistência:", error);
});

export { auth, db, storage };
